import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';

@Pipe({
  name: 'dobFormatter'
})
export class DobFormatterPipe implements PipeTransform {


  transform(value: any, format: any, timeZone?: any): any {
    if (value) {
      if (format) {
        value = moment(value, 'YYYY-MM-DD').format(format);
      } else {
        value = moment(value, 'YYYY-MM-DD').format('YYYY-MM-DD');
      }
    }
    return value;
  }

}
